import RoleManagement from '../components/RoleManagement/RoleManagement';
import PageLayout from '../components/pageLayout';

function RoleManagementPage() {
    return (
        <PageLayout children={<RoleManagement />} />
    );
}

export default RoleManagementPage;
